import DitherPrismHero from "@/components/feature/DitherPrismHero";
import MagneticButton from "@/components/base/MagneticButton";

export default function HeroSection() {
  return (
    <section className="relative w-full">
      <DitherPrismHero
        color1="#2b1a1a"
        color2="#b76e79"
        color3="#f7cac9"
        ditherIntensity={0.15}
        prismIntensity={0.4}
        showParticles={false}
        speed={0.8}
      >
        <div className="relative flex w-full flex-1 flex-col items-center justify-center pt-24 pb-16 md:pt-32 md:pb-24 px-6">
          {/* Headline */}
          <h1
            className="text-center text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white via-white/90 to-white/60 max-w-5xl"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Design at the speed
            <br />
            of imagination
          </h1>

          {/* Subheadline */}
          <p className="mt-6 max-w-2xl text-center text-base md:text-lg text-white/70 leading-relaxed">
            A prismatic, dithered design system for teams shipping the next
            wave of interfaces.
          </p>

          {/* CTA row with magnetic buttons */}
          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
            <MagneticButton
              href="#get-started"
              strength={0.35}
              className="group rounded-md bg-white px-6 py-3 text-sm font-semibold text-zinc-900 whitespace-nowrap cursor-pointer hover:bg-zinc-100"
            >
              Start building free
              <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"></i>
            </MagneticButton>
            <MagneticButton
              href="#demo"
              strength={0.3}
              className="group rounded-md border border-white/25 bg-white/5 px-6 py-3 text-sm font-semibold text-white backdrop-blur-md whitespace-nowrap cursor-pointer hover:bg-white/10"
            >
              <i className="ri-play-circle-line text-base"></i>
              Watch demo
            </MagneticButton>
          </div>
        </div>
      </DitherPrismHero>
    </section>
  );
}